import {createSlice, Dictionary, PayloadAction} from '@reduxjs/toolkit'
import {takeEvery, getContext, call, put} from 'typed-redux-saga'
import Api from '../../api/reactpt'
import {DataState} from '../../types/dataState.type'
import _ from 'lodash'
import ActionType from 'src/models/ActionType'
import {shouldLogUserOut} from '../configureStore'

export type ActionTypesState = {
  actionTypes: Dictionary<ActionType>
  dataState: DataState
}

const initialState: ActionTypesState = {
  actionTypes: {},
  dataState: {state: 'unloaded'},
}

export const {actions, reducer} = createSlice({
  name: 'actionTypes',
  initialState,
  reducers: {
    getActionTypes: (_state: ActionTypesState, _action: PayloadAction<void>) => {},
    setActionTypes: (
      state: ActionTypesState,
      action: PayloadAction<{actionTypes: ActionType[]}>,
    ) => {
      const keyed = _.keyBy(action.payload.actionTypes, ({id}) => id)
      const newActionTypes = {...keyed} as Dictionary<ActionType>
      return {...state, actionTypes: newActionTypes}
    },
    setDataState: (state: ActionTypesState, action: PayloadAction<{dataState: DataState}>) => {
      const {dataState} = action.payload
      return {...state, dataState}
    },
    clear: (_state: ActionTypesState) => {
      return {...initialState}
    },
  },
})

export const getActionTypesSaga = function* () {
  const api: Api = yield* getContext<Api>('api')
  yield* put(actions.setDataState({dataState: {state: 'loading'}}))
  try {
    const result = yield* call(api.getActionTypes)
    yield* put(actions.setActionTypes({actionTypes: result}))
    yield* put(actions.setDataState({dataState: {state: 'loaded'}}))
  } catch (error) {
    if (shouldLogUserOut(error)) {
      throw error
    } else {
      yield* put(actions.setDataState({dataState: {state: 'unloaded', error}}))
    }
  }
}

export const saga = function* () {
  yield* takeEvery(actions.getActionTypes.type, getActionTypesSaga)
}
